import { createFileRoute } from '@tanstack/react-router';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/_app/messages')({
  staticData: { crumb: 'Wiadomości' },
  component: MessagesPage,
});

function MessagesPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-2xl font-semibold tracking-tight text-text">
          Wiadomości
        </h1>
        <p className="mt-1 text-sm text-text-muted">
          Wiadomości z formularza kontaktowego są wysyłane bezpośrednio na Twój adres e-mail
          (lead-proxy). Tu zobaczysz historię (audyt) dostarczenia.
        </p>
      </header>
      <Card>
        <CardHeader>
          <CardTitle>Inbox audytowy — wkrótce</CardTitle>
          <CardDescription>
            Zachowujemy tylko ślad audytowy (znacznik czasu, hash IP, hash zgody, identyfikator
            wiadomości) — bez treści ani danych osobowych pacjentów (RODO Art. 28).
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-text-muted">
            Po uruchomieniu strony formularz zacznie kierować wiadomości na adres e-mail
            ustawiony w „Dane podstawowe → Kontakt".
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
